import { Search } from '@mui/icons-material'
import { Button, InputAdornment, Stack, TextField, Typography } from '@mui/material'
import React from 'react'

const FieldsHeader = (props: any) => {
  const { title, handleSave, handleBack, handleCancel, handleSearchChange } = props
  return (
    <>
      <Stack flexDirection={"row"} p={"8px"} justifyContent={"space-between"} border={"1px solid #E8E8E8"} bgcolor={"white"}>
        <Button
          id='hoa-cancel-click'
          variant="outlined"
          color="primary"
          style={{ height: "40px", padding: "5px 25px", marginRight: "5px", width: "101px" }}
          onClick={handleBack}
        >
          Back
        </Button>
        <Stack flexDirection={"row"} gap={"8px"} justifyContent={"space-between"}>
          <Button
            id='hoa-cancel-click'
            variant="outlined"
            color="primary"
            style={{ height: "40px", padding: "5px 25px", marginRight: "5px", width: "101px" }}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            // disabled={!selectedBillItem}
            id='hoa-save-click'
            variant="contained"
            color="primary"
            style={{ height: "40px", padding: "5px 25px", width: "187px", whiteSpace: "nowrap" }}
            onClick={handleSave}
          >
            Save Changes
          </Button>
        </Stack>
      </Stack>
      <Stack flexDirection={"row"} p={"16px"} justifyContent={"space-between"} border={"1px solid #E8E8E8"} bgcolor={"white"}>
        <Typography color={"#303030"} fontSize={"14px"} fontWeight={500}>Configure HOA {title}</Typography>
      </Stack>
      <Stack flexDirection={"row"} justifyContent={"space-between"} bgcolor={"white"}>
        <div style={{ width: "100%" }}>
          <TextField
            variant="outlined"
            placeholder={'Search'}
            fullWidth
            onChange={handleSearchChange}
            style={{ boxSizing: 'border-box' }}
            sx={{
              '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                borderColor: '#BDBDBD',
              },
              '& .MuiInputBase-root.Mui-focused fieldset': {
                borderColor: '#BDBDBD',
              },
              '& .MuiOutlinedInput-adornedEnd': {
                paddingRight: '0px',
              },
            }}
            InputProps={{
              margin: 'none',
              className: 'searchInputClass',
              startAdornment: (
                <InputAdornment position="start">
                  <Search style={{ color: '#9F9F9F' }} />
                </InputAdornment>
              ),
            }}
            type={'search'} />
        </div>
      </Stack>
    </>
  )
}

export default FieldsHeader

